import Vue from 'vue';
import axios from 'axios';

//TODO baseURL değerleri sitenin url i olacak https://hasretkemaliye.com:8443 gibi
//development anında baseURL: 'http://localhost:8085/api',
//baseURL: 'https://mamasonline.net/api',
const axiosInstance = axios.create({
  baseURL: 'https://mamasonline.net/api',
  timeout: 500000,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
      console.log("-------------ERROR----------------");
      console.log(error);
      switch (error.response.status) {
          case 401:
              throw new Error("Kullanıcı adınız veya şifreniz yanlış.");
          default:
              throw new Error(error.response.data.message);
      }
  },
);

axiosInstance.interceptors.request.use(
  (config) => {
    addBasicAuthenticationToHeader(config);
    return config
  },
  (error) => {
      throw error;
  },
);

function addBasicAuthenticationToHeader(config) {
  const user = JSON.parse(localStorage.getItem('user'));
    if (user !== undefined && user !== null) {
        const auth = 'Basic ' + new Buffer(user.username + ':' + user.password).toString('base64');
        config.headers['Authorization'] = auth;
    }
}

export default {
  install() {
    Vue.prototype.$axios = axiosInstance;
  },
};
